import { render, staticRenderFns } from "./BestSellingStat.vue?vue&type=template&id=2cbd6844&lang=pug&"
import script from "./BestSellingStat.vue?vue&type=script&lang=js&"
export * from "./BestSellingStat.vue?vue&type=script&lang=js&"
import style0 from "./BestSellingStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports